import React from 'react';

export interface AuthTextareaProps {
  id: string;
  label: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  required?: boolean;
  rows?: number;
  hint?: string;
  error?: string;
}

export function AuthTextarea({
  id,
  label,
  value,
  onChange,
  placeholder,
  required = false,
  rows = 3,
  hint,
  error,
}: AuthTextareaProps) {
  return (
    <div className="auth-field">
      <label htmlFor={id} className="auth-field__label">
        {label}
        {required ? <span className="req">*</span> : null}
      </label>
      <textarea
        id={id}
        className="auth-field__textarea"
        rows={rows}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
      />
      {hint ? <p className="auth-field__hint">{hint}</p> : null}
      {error ? <p className="auth-field__error">{error}</p> : null}
    </div>
  );
}

export default AuthTextarea;
